export default "/images/arrow-up-circle.svg?061f90dce01161d81b25dba56733a64e";